import { useState } from 'react';
import { PopoverMenu } from '@/components/PopoverMenu/PopoverMenu';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import PencilIcon from './PencilIcon.svg?react';
import TrashBagIcon from './TrashBagIcon.svg?react';
import { PopoverMenuItem } from '@/components/PopoverMenu/PopoverMenuItem';

type EditPopoverMenuProps = {
  onEdit: () => void;
  onDelete: () => void;
};

export const PopoverMenuActions = ({ onEdit, onDelete }: EditPopoverMenuProps) => {
  const [openPopover, setOpenPopover] = useState(false);
  const onToggleOpen = (open: boolean) => {
    setOpenPopover(open);
  };

  return (
    <PopoverMenu isOpen={openPopover} onToggleOpen={onToggleOpen}>
      <Box display='flex' flexDirection='column' padding='8px 0'>
        <PopoverMenuItem onClick={onEdit} icon={<PencilIcon />}>
          <Typography variant='bodySmall' color={COLORS.black} fontWeight='medium'>
            Edit
          </Typography>
        </PopoverMenuItem>
        <PopoverMenuItem onClick={onDelete} icon={<TrashBagIcon />}>
          <Typography variant='bodySmall' color={COLORS.red[400]} fontWeight='medium'>
            Delete
          </Typography>
        </PopoverMenuItem>
      </Box>
    </PopoverMenu>
  );
};
